import api from "./api";

interface BolePixInterface {
  id: number;
  nome: string;
}

export interface CreateBolePixConfigInterface {
  nome: string;
  file: string | null;
  cor1: string;
  cor2: string | null;
  msgE: string | null;
  msgS: string | null;
  msgW: string | null;
  idClientes: number[];
}

export default class BolePixApi {
  static createBolePix = async (body: BolePixInterface) => {
    try {
      const response = await api.post(`/bolepix/create`, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  static getAllBolePix = async () => {
    const response = await api.get("/bolepix");
    return response.data;
  };

  static getBolePixById = async (id: number) => {
    const response = await api.get(`/bolepix/${id}`);
    return response.data;
  };

  static getLinkedClients = async (bolePixId: number) => {
    const response = await api.get(`/bolepix/${bolePixId}/clientes`);
    return response.data;
  };

  static linkClientsToBolePix = async (
    bolePixId: number,
    clientIds: number[]
  ) => {
    try {
      const response = await api.put(
        `/bolepix/${bolePixId}/clientes`,
        clientIds
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  static getRatesByMarkup = async (
    idBolePix: number,
    idProduto?: number,
    idBandeira?: number
  ) => {
    const query = [];
    if (idProduto) query.push(`idProduto=${idProduto}`);
    if (idBandeira) query.push(`idBandeira=${idBandeira}`);
    const url = `/markup/${idBolePix}/valores${
      query.length ? `?${query.join("&")}` : ""
    }`;
    try {
      const response = await api.get(url);
      const normalizedData = response.data.map((item: any) => ({
        ...item,
        brandRates: {
          ...item.brandRates,
          rates: item.brandRates.rates.map((rate: any) => ({
            paymentType: rate.paymentType.toLowerCase(),
            rate: rate.rate,
            cashValue: rate.cashValue === 0 ? null : rate.cashValue,
          })),
        },
      }));
      return normalizedData;
    } catch (error) {
      throw error;
    }
  };

  static deleteMarkup = async (idMarkup: number) => {
    try {
      const response = await api.delete(`/markup/${idMarkup}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  static upsertBolepixConfig = async (body: FormData) => {
    try {
      const response = await api.post(`/BolepixConfig/upsert`, body, {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "*/*",
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  static getListBolepixConfig = async () => {
    try {
      const response = await api.get(`/BolepixConfig`);
      return response.data;
    } catch (error) {
      throw error;
    }
  };
}
